var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kibana-container"},[_c('iframe',{attrs:{"id":"myFrame","sandbox":"allow-scripts allow-same-origin","src":_vm.kibanaLocation,"height":_vm.dimensions.height-60,"width":_vm.dimensions.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }